// extracted by mini-css-extract-plugin
export default {"main":"checkbox_main__zdsRn"};